// Sheet.jsx
import React from 'react';
import './sheet.css';

const Sheet = () => {
    return (
        <section className="about section" id="about">
      <h2 className="section__title">Featured Products</h2>
      <span className="section__subtitle">Expertly Sourced Collection</span>
        <div className="embed-container">
            <iframe
                src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQCHjEcUkSi9bBd5UtRCHuosneygz_LVs-4cgTtSQyANUTeLwmqwQ6EX4VuXD3biPb6n0_cH77qrH56/pubhtml?widget=true&amp;headers=false"
                loading="lazy" // Lazy load the iframe
                title="Embedded Google Sheet"
            ></iframe>
        </div>
        </section>
    );
};

export default Sheet;
